export const appName = "JN System";
export const defaultRoute = "/tts";
